// extracted by mini-css-extract-plugin
module.exports = {"button":"EntityActions_button__2VSEa","icon":"EntityActions_icon__23W8l"};